import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import AttachModal from '@board/components/Modals/AttachModal.vue'
import CommentWrite from '@board/components/Read/CommentWrite.vue'
import CommentItem from '@board/components/Read/CommentItem.vue'
import * as accountTypes from '@account/store/types'
import * as dateutil from '@/util/date-helper'
import api from '@board/api'
import { EumEditor } from '@appbase/components/editor'
import { cache } from '@/modules/@appbase/util'
@Component({
    components: { 
        AttachModal, 
        CommentWrite,
        CommentItem,
        EumEditor
    },
    computed: {
        ...mapGetters({
            User: accountTypes.USER
        })
    }
})
export default class ReadContainer extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    currentBoard: number = 0
    currentArticle: number = 0

    article: article.ArticleDetail | null = null

    showAttachModal: boolean = false
    commentList: article.ArticleComment[] = []
    commnetPhotos: article.CommentPhoto[] = []
    commentCount: number = 0
    recommendCount: number = 0
    userRecommended: boolean = false

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    getDate(dateStr: string, format: string) {
        return dateutil.uGetDateFormat(format, dateutil.IEDate(dateStr))
    }

    loadComment(articleId: number) {
        var data: article.CommentFetchSet = {
            articleId: articleId,
            page: 1,
            itemsPerPage: 50
        }
        api.article.getArticleComments(data).then(res => {
            this.commentCount = res.data.length
            this.commentList = this.sortComments(res.data)
            this.loadCommentPhotos(this.commentList, this.commentCount)
        })
    }

    loadCommentPhotos(comments: article.ArticleComment[], length: number) {
        var photoPromise: Promise<string>[] = []; 
        
        comments.forEach(c => photoPromise.push(cache.avatar.get(c.userCode)));
        Promise.all(photoPromise)
            .then(res => {
                this.commnetPhotos = res.map(r => <article.CommentPhoto>{ photoUrl: r, isReplyModel: false });
            });
    }    

    getRecommentList(articleId: number) {
        api.article.getRecommendList(articleId).then(res => {
            this.recommendCount = res.length
            this.userRecommended = res.filter(r => r.userCode == this.User.personCode).length > 0
        })
    }

    recommendArticle() {
        var userset = <article.CreateOptionSet>{
            articleId: this.currentArticle,
            deptName: this.User.deptName,
            deptName_En: this.User.deptNameEn,
            userCode: this.User.id,
            userJobTitle: this.User.titleName,
            userJobTitle_En: this.User.titleNameEn,
            userName: this.User.displayName,
            userName_En: this.User.displayDeptNameEn
        }

        var recommendPromise = this.userRecommended ? 
            api.article.deleteRecommend(userset) :
            api.article.createRecommend(userset);

        recommendPromise.then(res => { this.getRecommentList(this.currentArticle) });
    }

    sortComments(comments: article.ArticleComment[]) {
        var returnModel: any[] = comments.filter(c => c.replyTo == null);

        var appendReplies = function(remains: article.ArticleComment[]) {
            if(remains.length == 0)
                return;

            console.log('remains', remains)
  
            var nextRemains: article.ArticleComment[] = [];       
            remains.forEach(r => {
                var idx = returnModel.findIndex(m => m.commentId == r.replyTo);

                if(idx >= 0 ) {
                    var parentComment = returnModel[idx];
                    var model = {
                        ...r,
                        replyToName: parentComment.userName
                    }

                    returnModel.splice(idx + 1, 0, model);
                } else {
                    nextRemains.push(r);
                }
            });

            appendReplies(nextRemains);
        }

        appendReplies(comments.filter(c => c.replyTo != null));    
        return returnModel.map(m => <any>{
            ...m,
            contentAfter: m.content,
            onEdit: false,
            isReplyModel: false
        })
    }

    createViewLog() {
        var data: article.CreateOptionSet = {
            articleId: this.currentArticle,
            userCode: this.User.personCode,
            userName: this.User.displayName,
            userName_En: this.User.displayNameEng,
            userMail: this.User.email,
            userDept: this.User.deptCode,
            userPhone: this.User.officeTel,
            deptName: this.User.deptName,
            deptName_En: this.User.deptNameEn,
            userJobTitle: this.User.titleName,
            userJobTitle_En: this.User.titleNameEn
        }
        api.article.createViewLog(data)
    }

    deleteItem() {
        if(this.$t('M_BB_DeleteMessage').toString()) {
            api.article.deleteArticle(<article.DeleteArticle>{
                articleId: this.currentArticle,
                deleteUser: {
                    userCode: this.User.id,
                    userName: this.User.displayName,
                    userName_En: this.User.displayDeptNameEn,
                    deptName: this.User.titleName,
                    deptName_En: this.User.titleNameEn,
                    userJobTitle: this.User.deptName,
                    userJobTitle_En: this.User.deptNameEn
                }
            }).then(res => {
                this.$router.push({ path: `/board/list?id=${this.currentBoard}` });
            })
        }
    }

    getArticleDetail(boardId: number, articleId: number) {
        api.article.getArticleDetail(boardId, articleId).then(res => {
            this.isloading(false)
            this.article = res

            if (this.article.commentCount > 0)
                this.loadComment(this.currentArticle)

            if (this.article.recommendCount > 0) 
                this.getRecommentList(this.currentArticle)
        })
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.isloading(true)
        var { boardId, articleId } = this.$route.query
        if(boardId) this.currentBoard = Number(boardId);
        if(articleId) this.currentArticle = Number(articleId);
        
        this.getArticleDetail(this.currentBoard, this.currentArticle)
        this.createViewLog()
    }
}
